import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import * as Const from "../../pages/amex/constants/ReportConstants";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {ID_FILTER_DEALERS, ID_FILTER_LEGAL_ENTITIES} from "../../pages/amex/constants/ReportConstants";

export const useAmexReportsRepository = () => {
    const { GET, POST, PUT } = useApi();

    const PATH = "/finance/amexsof/reports";


    const {
        globalData: { user },
    } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => x.name);

    const DATE_FIELDS = [
        Const.ID_FILTER_CREATION_DATE_FROM,
        Const.ID_FILTER_CREATION_DATE_TO,
        Const.ID_FILTER_PAYMENT_DATE_FROM,
        Const.ID_FILTER_PAYMENT_DATE_TO
    ];
    const OTHER_FIELDS = [
        Const.ID_FILTER_REPORT_NAME,
        Const.ID_FILTER_STATUS
    ];


    async function downloadReport(id: string, resetDate: boolean): Promise<HTTPGenericResponse> {
        let params = {
            resetDate: resetDate
        }
        let response = await GET(`${PATH}/${id}/download`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, true);
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    function reportSummary(
        filterDefs: FilterDef[] = []
    ): Promise<HTTPGenericResponse> {
        let params: any = {legalEntities : allLegalEntities};
        DATE_FIELDS.forEach((p) => {
            let date: Date = getFilterValue(p, filterDefs);
            params[p] = date ? dayjs(date).toISOString() : null;
        });
        OTHER_FIELDS.forEach((p) => {
            params[p] = getFilterValue(p, filterDefs);

        });
        return GET(`${PATH}/all-status-summary`, {
            params: params,
            paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
        });
    }

    async function getReports(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let reportName = getFilterValue(Const.ID_FILTER_REPORT_NAME, filterDefs);
        let statuses = getFilterValue(Const.ID_FILTER_STATUS, filterDefs);
        let creationDateFrom: Date = getFilterValue(Const.ID_FILTER_CREATION_DATE_FROM, filterDefs);
        let creationDateTo: Date = getFilterValue(Const.ID_FILTER_CREATION_DATE_TO, filterDefs);
        let paymentDateFrom: Date = getFilterValue(Const.ID_FILTER_PAYMENT_DATE_FROM, filterDefs);
        let paymentDateTo: Date = getFilterValue(Const.ID_FILTER_PAYMENT_DATE_TO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sortBy: sort,
            order: order,
            status: statuses,
            reportName: reportName,
            creationDateFrom: creationDateFrom ? dayjs(creationDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'): null,
            creationDateTo: creationDateTo ? dayjs(creationDateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')  : null,
            paymentDateFrom: paymentDateFrom ? dayjs(paymentDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
            paymentDateTo: paymentDateTo ? dayjs(paymentDateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')  : null,
            legalEntities,
            dealers
        }

        let response = await GET(`${PATH}`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    async function uploadFile(file: File, legalEntity: string, dealer: string): Promise<HTTPGenericResponse> {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("legalEntity", legalEntity);
        formData.append("dealer", dealer);
        return POST(`${PATH}/upload`, formData,
            { headers: { "Content-Type": "multipart/form-data" } }, true)
    }

    async function generateReport(legalEntity: string, dealer: string): Promise<HTTPGenericResponse> {
        let params = {
            legalEntity: legalEntity,
            dealer: dealer
        }

        let response = await PUT(`${PATH}/generate`,{},{ params: params, paramsSerializer: (params:any) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) },  true);
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }


    return { getReports, downloadReport, reportSummary, uploadFile, generateReport };
}